// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/user.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Pagination, PaginationMetadata } from "./core_pb";
import { file_api_gateway_v1_core } from "./core_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/user.proto.
 */
export const file_api_gateway_v1_user: GenFile = /*@__PURE__*/
  fileDesc("ChlhcGkvZ2F0ZXdheS92MS91c2VyLnByb3RvEgpnYXRld2F5LnYxItEBCgRVc2VyEgwKBHV1aWQYASABKAkSDAoEbmFtZRgCIAEoCRINCgVlbWFpbBgDIAEoCRIiCgRyb2xlGAQgASgOMhQuZ2F0ZXdheS52MS5Vc2VyUm9sZRI1Cg5hY2NvdW50X3N0YXR1cxgFIAEoDjIdLmdhdGV3YXkudjEuVXNlckFjY291bnRTdGF0dXMSLgoKY3JlYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEwoLdGVuYW50X3V1aWQYByABKAkiaQoRQ3JlYXRlVXNlclJlcXVlc3QSDAoEbmFtZRgBIAEoCRINCgVlbWFpbBgCIAEoCRIiCgRyb2xlGAMgASgOMhQuZ2F0ZXdheS52MS5Vc2VyUm9sZRITCgt0ZW5hbnRfdXVpZBgEIAEoCSJQChJDcmVhdGVVc2VyUmVzcG9uc2USHgoEdXNlchgBIAEoCzIQLmdhdGV3YXkudjEuVXNlchIaChJ0ZW1wb3JhcnlfcGFzc3dvcmQYAiABKAkidwoRVXBkYXRlVXNlclJlcXVlc3QSDAoEdXVpZBgBIAEoCRIMCgRuYW1lGAIgASgJEg0KBWVtYWlsGAMgASgJEiIKBHJvbGUYBCABKA4yFC5nYXRld2F5LnYxLlVzZXJSb2xlEhMKC3RlbmFudF91dWlkGAUgASgJIjQKElVwZGF0ZVVzZXJSZXNwb25zZRIeCgR1c2VyGAEgASgLMhAuZ2F0ZXdheS52MS5Vc2VyIiQKFEdldFVzZXJCeVV1aWRSZXF1ZXN0EgwKBHV1aWQYASABKAkiNwoVR2V0VXNlckJ5VXVpZFJlc3BvbnNlEh4KBHVzZXIYASABKAsyEC5nYXRld2F5LnYxLlVzZXIiRAoWTGlzdFVzZXJzQnlQYWdlUmVxdWVzdBIqCgpwYWdpbmF0aW9uGAEgASgLMhYuZ2F0ZXdheS52MS5QYWdpbmF0aW9uImwKF0xpc3RVc2Vyc0J5UGFnZVJlc3BvbnNlEh8KBXVzZXJzGAEgAygLMhAuZ2F0ZXdheS52MS5Vc2VyEjAKCG1ldGFkYXRhGAIgASgLMh4uZ2F0ZXdheS52MS5QYWdpbmF0aW9uTWV0YWRhdGEiNwogR2V0Q29tcGFueUFkbWluRnJvbVRlbmFudFJlcXVlc3QSEwoLdGVuYW50X3V1aWQYASABKAkiTQohR2V0Q29tcGFueUFkbWluRnJvbVRlbmFudFJlc3BvbnNlEigKDmNvbXBhbnlfYWRtaW5zGAEgAygLMhAuZ2F0ZXdheS52MS5Vc2VyIiUKEEJsb2NrVXNlclJlcXVlc3QSEQoJdXNlcl91dWlkGAEgASgJIjMKEUJsb2NrVXNlclJlc3BvbnNlEh4KBHVzZXIYASABKAsyEC5nYXRld2F5LnYxLlVzZXIiJwoSVW5ibG9ja1VzZXJSZXF1ZXN0EhEKCXVzZXJfdXVpZBgBIAEoCSI1ChNVbmJsb2NrVXNlclJlc3BvbnNlEh4KBHVzZXIYASABKAsyEC5nYXRld2F5LnYxLlVzZXIiTgoVVXBkYXRlVXNlclJvbGVSZXF1ZXN0EhEKCXVzZXJfdXVpZBgBIAEoCRIiCgRyb2xlGAIgASgOMhQuZ2F0ZXdheS52MS5Vc2VyUm9sZSI4ChZVcGRhdGVVc2VyUm9sZVJlc3BvbnNlEh4KBHVzZXIYASABKAsyEC5nYXRld2F5LnYxLlVzZXIiQwoYUmVzZXRVc2VyUGFzc3dvcmRSZXF1ZXN0EhEKCXVzZXJfdXVpZBgBIAEoCRIUCgxuZXdfcGFzc3dvcmQYAiABKAkiGwoZUmVzZXRVc2VyUGFzc3dvcmRSZXNwb25zZSqGAQoIVXNlclJvbGUSGQoVVVNFUl9ST0xFX1VOU1BFQ0lGSUVEEAASGQoVVVNFUl9ST0xFX1NVUEVSX0FETUlOEAESGwoXVVNFUl9ST0xFX0NPTVBBTllfQURNSU4QAhITCg9VU0VSX1JPTEVfQURNSU4QAxISCg5VU0VSX1JPTEVfVVNFUhAEKnkKEVVzZXJBY2NvdW50U3RhdHVzEiMKH1VTRVJfQUNDT1VOVF9TVEFUVVNfVU5TUEVDSUZJRUQQABIeChpVU0VSX0FDQ09VTlRfU1RBVFVTX0FDVElWRRABEh8KG1VTRVJfQUNDT1VOVF9TVEFUVVNfQkxPQ0tFRBACMrIGChVVc2VyTWFuYWdlbWVudFNlcnZpY2USSwoKQ3JlYXRlVXNlchIdLmdhdGV3YXkudjEuQ3JlYXRlVXNlclJlcXVlc3QaHi5nYXRld2F5LnYxLkNyZWF0ZVVzZXJSZXNwb25zZRJLCgpVcGRhdGVVc2VyEh0uZ2F0ZXdheS52MS5VcGRhdGVVc2VyUmVxdWVzdBoeLmdhdGV3YXkudjEuVXBkYXRlVXNlclJlc3BvbnNlElQKDUdldFVzZXJCeVV1aWQSIC5nYXRld2F5LnYxLkdldFVzZXJCeVV1aWRSZXF1ZXN0GiEuZ2F0ZXdheS52MS5HZXRVc2VyQnlVdWlkUmVzcG9uc2USWgoPTGlzdFVzZXJzQnlQYWdlEiIuZ2F0ZXdheS52MS5MaXN0VXNlcnNCeVBhZ2VSZXF1ZXN0GiMuZ2F0ZXdheS52MS5MaXN0VXNlcnNCeVBhZ2VSZXNwb25zZRJ4ChlHZXRDb21wYW55QWRtaW5Gcm9tVGVuYW50EiwuZ2F0ZXdheS52MS5HZXRDb21wYW55QWRtaW5Gcm9tVGVuYW50UmVxdWVzdBotLmdhdGV3YXkudjEuR2V0Q29tcGFueUFkbWluRnJvbVRlbmFudFJlc3BvbnNlEkgKCUJsb2NrVXNlchIcLmdhdGV3YXkudjEuQmxvY2tVc2VyUmVxdWVzdBodLmdhdGV3YXkudjEuQmxvY2tVc2VyUmVzcG9uc2USTgoLVW5ibG9ja1VzZXISHi5nYXRld2F5LnYxLlVuYmxvY2tVc2VyUmVxdWVzdBofLmdhdGV3YXkudjEuVW5ibG9ja1VzZXJSZXNwb25zZRJXCg5VcGRhdGVVc2VyUm9sZRIhLmdhdGV3YXkudjEuVXBkYXRlVXNlclJvbGVSZXF1ZXN0GiIuZ2F0ZXdheS52MS5VcGRhdGVVc2VyUm9sZVJlc3BvbnNlEmAKEVJlc2V0VXNlclBhc3N3b3JkEiQuZ2F0ZXdheS52MS5SZXNldFVzZXJQYXNzd29yZFJlcXVlc3QaJS5nYXRld2F5LnYxLlJlc2V0VXNlclBhc3N3b3JkUmVzcG9uc2VCZAoOY29tLmdhdGV3YXkudjFCCVVzZXJQcm90b1ABogIDR1hYqgIKR2F0ZXdheS5WMcoCCkdhdGV3YXlcVjHiAhZHYXRld2F5XFYxXEdQQk1ldGFkYXRh6gILR2F0ZXdheTo6VjFiBnByb3RvMw", [file_api_gateway_v1_core, file_google_protobuf_timestamp]);

/**
 * User represents a user account in the system.
 *
 * @generated from message gateway.v1.User
 */
export type User = Message<"gateway.v1.User"> & {
  /**
   * uuid is the unique identifier for the user.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the display name of the user.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * email is the user's email address.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * role is the user's assigned role in the system.
   *
   * @generated from field: gateway.v1.UserRole role = 4;
   */
  role: UserRole;

  /**
   * account_status is the current status of the user's account.
   *
   * @generated from field: gateway.v1.UserAccountStatus account_status = 5;
   */
  accountStatus: UserAccountStatus;

  /**
   * created_at is the timestamp when the user was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * tenant_uuid is the unique identifier of the tenant that owns this user, used for multi-tenancy support.
   *
   * @generated from field: string tenant_uuid = 7;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 0);

/**
 * ----------------------------------------------------------------------------
 * Create User
 * ----------------------------------------------------------------------------
 *
 * @generated from message gateway.v1.CreateUserRequest
 */
export type CreateUserRequest = Message<"gateway.v1.CreateUserRequest"> & {
  /**
   * name is the display name for the new user.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * email is the email address for the new user.
   *
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * role is the role to assign to the new user.
   *
   * @generated from field: gateway.v1.UserRole role = 3;
   */
  role: UserRole;

  /**
   * tenant_uuid is the unique identifier of the tenant that will own this user, used for multi-tenancy support.
   *
   * @generated from field: string tenant_uuid = 4;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.CreateUserRequest.
 * Use `create(CreateUserRequestSchema)` to create a new message.
 */
export const CreateUserRequestSchema: GenMessage<CreateUserRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 1);

/**
 * @generated from message gateway.v1.CreateUserResponse
 */
export type CreateUserResponse = Message<"gateway.v1.CreateUserResponse"> & {
  /**
   * user is the newly created user.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;

  /**
   * TemporaryPassword is the initial password for the new user, which should be changed upon first login.
   *
   * @generated from field: string temporary_password = 2;
   */
  temporaryPassword: string;
};

/**
 * Describes the message gateway.v1.CreateUserResponse.
 * Use `create(CreateUserResponseSchema)` to create a new message.
 */
export const CreateUserResponseSchema: GenMessage<CreateUserResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 2);

/**
 * UpdateUserRequest is the request message for updating an existing user.
 *
 * @generated from message gateway.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"gateway.v1.UpdateUserRequest"> & {
  /**
   * uuid is the unique identifier of the user to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * name is the new display name for the user.
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * email is the new email address for the user.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * role is the new role to assign to the user.
   *
   * @generated from field: gateway.v1.UserRole role = 4;
   */
  role: UserRole;

  /**
   * tenant_uuid is the new tenant assignment for the user (only SUPER_ADMIN with empty tenant can modify).
   *
   * @generated from field: string tenant_uuid = 5;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 3);

/**
 * UpdateUserResponse is the response message for the UpdateUser RPC.
 *
 * @generated from message gateway.v1.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"gateway.v1.UpdateUserResponse"> & {
  /**
   * user is the updated user.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gateway.v1.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 4);

/**
 * GetUserByUuidRequest is the request message for retrieving a user by UUID.
 *
 * @generated from message gateway.v1.GetUserByUuidRequest
 */
export type GetUserByUuidRequest = Message<"gateway.v1.GetUserByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the user to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetUserByUuidRequest.
 * Use `create(GetUserByUuidRequestSchema)` to create a new message.
 */
export const GetUserByUuidRequestSchema: GenMessage<GetUserByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 5);

/**
 * GetUserByUuidResponse is the response message for the GetUserByUuid RPC.
 *
 * @generated from message gateway.v1.GetUserByUuidResponse
 */
export type GetUserByUuidResponse = Message<"gateway.v1.GetUserByUuidResponse"> & {
  /**
   * user is the retrieved user.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gateway.v1.GetUserByUuidResponse.
 * Use `create(GetUserByUuidResponseSchema)` to create a new message.
 */
export const GetUserByUuidResponseSchema: GenMessage<GetUserByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 6);

/**
 * ListUsersByPageRequest is the request message for listing users with pagination.
 *
 * @generated from message gateway.v1.ListUsersByPageRequest
 */
export type ListUsersByPageRequest = Message<"gateway.v1.ListUsersByPageRequest"> & {
  /**
   * pagination contains the pagination parameters.
   *
   * @generated from field: gateway.v1.Pagination pagination = 1;
   */
  pagination?: Pagination | undefined;
};

/**
 * Describes the message gateway.v1.ListUsersByPageRequest.
 * Use `create(ListUsersByPageRequestSchema)` to create a new message.
 */
export const ListUsersByPageRequestSchema: GenMessage<ListUsersByPageRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 7);

/**
 * ListUsersByPageResponse is the response message for the ListUsersByPage RPC.
 *
 * @generated from message gateway.v1.ListUsersByPageResponse
 */
export type ListUsersByPageResponse = Message<"gateway.v1.ListUsersByPageResponse"> & {
  /**
   * users is the list of users for the requested page.
   *
   * @generated from field: repeated gateway.v1.User users = 1;
   */
  users: User[];

  /**
   * metadata contains the pagination metadata for the response.
   *
   * @generated from field: gateway.v1.PaginationMetadata metadata = 2;
   */
  metadata?: PaginationMetadata | undefined;
};

/**
 * Describes the message gateway.v1.ListUsersByPageResponse.
 * Use `create(ListUsersByPageResponseSchema)` to create a new message.
 */
export const ListUsersByPageResponseSchema: GenMessage<ListUsersByPageResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 8);

/**
 * GetCompanyAdminFromTenantRequest is the request message for retrieving the company admins of a tenant.
 *
 * @generated from message gateway.v1.GetCompanyAdminFromTenantRequest
 */
export type GetCompanyAdminFromTenantRequest = Message<"gateway.v1.GetCompanyAdminFromTenantRequest"> & {
  /**
   * tenant_uuid is the unique identifier of the tenant whose company admins will be retrieved.
   *
   * @generated from field: string tenant_uuid = 1;
   */
  tenantUuid: string;
};

/**
 * Describes the message gateway.v1.GetCompanyAdminFromTenantRequest.
 * Use `create(GetCompanyAdminFromTenantRequestSchema)` to create a new message.
 */
export const GetCompanyAdminFromTenantRequestSchema: GenMessage<GetCompanyAdminFromTenantRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 9);

/**
 * GetCompanyAdminFromTenantResponse is the response message for the GetCompanyAdminFromTenant RPC.
 *
 * @generated from message gateway.v1.GetCompanyAdminFromTenantResponse
 */
export type GetCompanyAdminFromTenantResponse = Message<"gateway.v1.GetCompanyAdminFromTenantResponse"> & {
  /**
   * company_admins is the list of users with the COMPANY_ADMIN role assigned to the tenant.
   *
   * @generated from field: repeated gateway.v1.User company_admins = 1;
   */
  companyAdmins: User[];
};

/**
 * Describes the message gateway.v1.GetCompanyAdminFromTenantResponse.
 * Use `create(GetCompanyAdminFromTenantResponseSchema)` to create a new message.
 */
export const GetCompanyAdminFromTenantResponseSchema: GenMessage<GetCompanyAdminFromTenantResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 10);

/**
 * BlockUserRequest is the request message for blocking a user account.
 *
 * @generated from message gateway.v1.BlockUserRequest
 */
export type BlockUserRequest = Message<"gateway.v1.BlockUserRequest"> & {
  /**
   * user_uuid is the unique identifier of the user to block.
   *
   * @generated from field: string user_uuid = 1;
   */
  userUuid: string;
};

/**
 * Describes the message gateway.v1.BlockUserRequest.
 * Use `create(BlockUserRequestSchema)` to create a new message.
 */
export const BlockUserRequestSchema: GenMessage<BlockUserRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 11);

/**
 * BlockUserResponse is the response message for the BlockUser RPC.
 *
 * @generated from message gateway.v1.BlockUserResponse
 */
export type BlockUserResponse = Message<"gateway.v1.BlockUserResponse"> & {
  /**
   * user is the blocked user with updated status.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gateway.v1.BlockUserResponse.
 * Use `create(BlockUserResponseSchema)` to create a new message.
 */
export const BlockUserResponseSchema: GenMessage<BlockUserResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 12);

/**
 * UnblockUserRequest is the request message for unblocking a user account.
 *
 * @generated from message gateway.v1.UnblockUserRequest
 */
export type UnblockUserRequest = Message<"gateway.v1.UnblockUserRequest"> & {
  /**
   * user_uuid is the unique identifier of the user to unblock.
   *
   * @generated from field: string user_uuid = 1;
   */
  userUuid: string;
};

/**
 * Describes the message gateway.v1.UnblockUserRequest.
 * Use `create(UnblockUserRequestSchema)` to create a new message.
 */
export const UnblockUserRequestSchema: GenMessage<UnblockUserRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 13);

/**
 * UnblockUserResponse is the response message for the UnblockUser RPC.
 *
 * @generated from message gateway.v1.UnblockUserResponse
 */
export type UnblockUserResponse = Message<"gateway.v1.UnblockUserResponse"> & {
  /**
   * user is the unblocked user with updated status.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gateway.v1.UnblockUserResponse.
 * Use `create(UnblockUserResponseSchema)` to create a new message.
 */
export const UnblockUserResponseSchema: GenMessage<UnblockUserResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 14);

/**
 * UpdateUserRoleRequest is the request message for changing a user's role.
 *
 * @generated from message gateway.v1.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequest = Message<"gateway.v1.UpdateUserRoleRequest"> & {
  /**
   * user_uuid is the unique identifier of the user whose role will be updated.
   *
   * @generated from field: string user_uuid = 1;
   */
  userUuid: string;

  /**
   * role is the new role to assign to the user.
   *
   * @generated from field: gateway.v1.UserRole role = 2;
   */
  role: UserRole;
};

/**
 * Describes the message gateway.v1.UpdateUserRoleRequest.
 * Use `create(UpdateUserRoleRequestSchema)` to create a new message.
 */
export const UpdateUserRoleRequestSchema: GenMessage<UpdateUserRoleRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 15);

/**
 * UpdateUserRoleResponse is the response message for the UpdateUserRole RPC.
 *
 * @generated from message gateway.v1.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponse = Message<"gateway.v1.UpdateUserRoleResponse"> & {
  /**
   * user is the user with the updated role.
   *
   * @generated from field: gateway.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gateway.v1.UpdateUserRoleResponse.
 * Use `create(UpdateUserRoleResponseSchema)` to create a new message.
 */
export const UpdateUserRoleResponseSchema: GenMessage<UpdateUserRoleResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 16);

/**
 * ResetUserPasswordRequest is the request message for resetting a user's password.
 *
 * @generated from message gateway.v1.ResetUserPasswordRequest
 */
export type ResetUserPasswordRequest = Message<"gateway.v1.ResetUserPasswordRequest"> & {
  /**
   * user_uuid is the unique identifier of the user whose password will be reset.
   *
   * @generated from field: string user_uuid = 1;
   */
  userUuid: string;

  /**
   * new_password is the new password to set for the user, which should be permanent and not require a reset on next login.
   *
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message gateway.v1.ResetUserPasswordRequest.
 * Use `create(ResetUserPasswordRequestSchema)` to create a new message.
 */
export const ResetUserPasswordRequestSchema: GenMessage<ResetUserPasswordRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 17);

/**
 * @generated from message gateway.v1.ResetUserPasswordResponse
 */
export type ResetUserPasswordResponse = Message<"gateway.v1.ResetUserPasswordResponse"> & {
};

/**
 * Describes the message gateway.v1.ResetUserPasswordResponse.
 * Use `create(ResetUserPasswordResponseSchema)` to create a new message.
 */
export const ResetUserPasswordResponseSchema: GenMessage<ResetUserPasswordResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_user, 18);

/**
 * UserRole defines the possible roles a user can have in the system.
 *
 * @generated from enum gateway.v1.UserRole
 */
export enum UserRole {
  /**
   * USER_ROLE_UNSPECIFIED is the default value when no role is set.
   *
   * @generated from enum value: USER_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * USER_ROLE_SUPER_ADMIN grants full system-wide administrative privileges.
   *
   * @generated from enum value: USER_ROLE_SUPER_ADMIN = 1;
   */
  SUPER_ADMIN = 1,

  /**
   * USER_ROLE_COMPANY_ADMIN grants administrative privileges within assigned scope.
   *
   * @generated from enum value: USER_ROLE_COMPANY_ADMIN = 2;
   */
  COMPANY_ADMIN = 2,

  /**
   * USER_ROLE_ADMIN grants technical privileges within assigned scope.
   *
   * @generated from enum value: USER_ROLE_ADMIN = 3;
   */
  ADMIN = 3,

  /**
   * USER_ROLE_USER grants standard user privileges.
   *
   * @generated from enum value: USER_ROLE_USER = 4;
   */
  USER = 4,
}

/**
 * Describes the enum gateway.v1.UserRole.
 */
export const UserRoleSchema: GenEnum<UserRole> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_user, 0);

/**
 * UserAccountStatus defines the possible states of a user account.
 *
 * @generated from enum gateway.v1.UserAccountStatus
 */
export enum UserAccountStatus {
  /**
   * USER_ACCOUNT_STATUS_UNSPECIFIED is the default value when no status is set.
   *
   * @generated from enum value: USER_ACCOUNT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * USER_ACCOUNT_STATUS_ACTIVE indicates the account is active and can access the system.
   *
   * @generated from enum value: USER_ACCOUNT_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * USER_ACCOUNT_STATUS_BLOCKED indicates the account is blocked and cannot access the system.
   *
   * @generated from enum value: USER_ACCOUNT_STATUS_BLOCKED = 2;
   */
  BLOCKED = 2,
}

/**
 * Describes the enum gateway.v1.UserAccountStatus.
 */
export const UserAccountStatusSchema: GenEnum<UserAccountStatus> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_user, 1);

/**
 * UserManagementService defines the gRPC service for managing users and their location access.
 *
 * @generated from service gateway.v1.UserManagementService
 */
export const UserManagementService: GenService<{
  /**
   * -------------------------------------------------------------------------
   * User CRUD operations
   * -------------------------------------------------------------------------
   * CreateUser creates a new user account in the system.
   *
   * @generated from rpc gateway.v1.UserManagementService.CreateUser
   */
  createUser: {
    methodKind: "unary";
    input: typeof CreateUserRequestSchema;
    output: typeof CreateUserResponseSchema;
  },
  /**
   * UpdateUser updates a user's name and email.
   *
   * @generated from rpc gateway.v1.UserManagementService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
  /**
   * GetUserByUuid retrieves a user by their unique identifier.
   *
   * @generated from rpc gateway.v1.UserManagementService.GetUserByUuid
   */
  getUserByUuid: {
    methodKind: "unary";
    input: typeof GetUserByUuidRequestSchema;
    output: typeof GetUserByUuidResponseSchema;
  },
  /**
   * ListUsersByPage retrieves a paginated list of users.
   *
   * @generated from rpc gateway.v1.UserManagementService.ListUsersByPage
   */
  listUsersByPage: {
    methodKind: "unary";
    input: typeof ListUsersByPageRequestSchema;
    output: typeof ListUsersByPageResponseSchema;
  },
  /**
   * GetCompanyAdminFromTenant retrieves the company admin users belonging to a given tenant.
   *
   * @generated from rpc gateway.v1.UserManagementService.GetCompanyAdminFromTenant
   */
  getCompanyAdminFromTenant: {
    methodKind: "unary";
    input: typeof GetCompanyAdminFromTenantRequestSchema;
    output: typeof GetCompanyAdminFromTenantResponseSchema;
  },
  /**
   * BlockUser blocks a user account, preventing them from accessing the system.
   *
   * @generated from rpc gateway.v1.UserManagementService.BlockUser
   */
  blockUser: {
    methodKind: "unary";
    input: typeof BlockUserRequestSchema;
    output: typeof BlockUserResponseSchema;
  },
  /**
   * UnblockUser unblocks a previously blocked user account, restoring their access.
   *
   * @generated from rpc gateway.v1.UserManagementService.UnblockUser
   */
  unblockUser: {
    methodKind: "unary";
    input: typeof UnblockUserRequestSchema;
    output: typeof UnblockUserResponseSchema;
  },
  /**
   * UpdateUserRole changes the role assigned to a user.
   *
   * @generated from rpc gateway.v1.UserManagementService.UpdateUserRole
   */
  updateUserRole: {
    methodKind: "unary";
    input: typeof UpdateUserRoleRequestSchema;
    output: typeof UpdateUserRoleResponseSchema;
  },
  /**
   * @generated from rpc gateway.v1.UserManagementService.ResetUserPassword
   */
  resetUserPassword: {
    methodKind: "unary";
    input: typeof ResetUserPasswordRequestSchema;
    output: typeof ResetUserPasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_user, 0);

